var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.container, _vm.computedClasses],
    on: {
      "click": _vm.handleFocus
    }
  }, [_c('div', {
    class: _vm.$style.inner
  }, [_c('div', {
    class: _vm.$style.wrapper
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('label', {
    class: [_vm.$style.label, _vm.computedClasses],
    attrs: {
      "for": _vm.internalId
    },
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm.useCounter ? _c('div', {
    directives: [{
      name: "color",
      rawName: "v-color",
      value: _vm.internalFocus ? 'black-2' : 'white',
      expression: "internalFocus ? 'black-2' : 'white'"
    }, {
      name: "opacity",
      rawName: "v-opacity",
      value: .5,
      expression: ".5"
    }],
    domProps: {
      "textContent": _vm._s(_vm.counter)
    }
  }) : _vm._e(), _vm.disabled ? _c('base-icon', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "color",
      rawName: "v-color:grey",
      arg: "grey"
    }],
    attrs: {
      "name": "security_lock-circle"
    }
  }) : _vm.error ? _c('base-icon', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "color",
      rawName: "v-color:red",
      arg: "red"
    }],
    attrs: {
      "name": "notifications_alert-circle"
    }
  }) : _vm.helpLink ? _c('help-link', {
    directives: [{
      name: "color",
      rawName: "v-color",
      value: _vm.internalFocus ? 'violet' : 'white',
      expression: "internalFocus ? 'violet' : 'white'"
    }],
    attrs: {
      "source": _vm.helpLink
    }
  }) : _vm._e(), _vm.$scopedSlots.hasOwnProperty('icon') ? _c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }],
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("icon", null, {
    "focus": _vm.internalFocus
  })], 2) : _vm._e()], 1), _c('div', {
    class: _vm.$style.content
  }, [_c(_vm.currentComponent, {
    ref: _vm.internalRef,
    tag: "component",
    attrs: {
      "id": _vm.internalId,
      "type": _vm.type,
      "value": _vm.value,
      "inputmode": _vm.inputmode,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "force-replace": _vm.forceReplace,
      "force-format": _vm.forceFormat
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "submit": _vm.handleSubmit,
      "keydown": _vm.handleKeydown
    }
  }), _vm.$slots.hasOwnProperty('target-link') ? _c('div', {
    class: _vm.$style.link
  }, [_vm._t("target-link")], 2) : _vm._e()], 1)]), _vm.$slots.hasOwnProperty('attachment') ? _c('div', {
    class: _vm.$style.attachment,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("attachment")], 2) : _vm._e()]), _vm.$slots.hasOwnProperty('button') ? _c('div', {
    class: _vm.$style.button,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("button")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }